import React, { useState } from 'react';
import { css } from 'emotion';
import AppHeader from '../app-header';
import { connect } from 'react-redux';
import TextField from '../textfield';
import { push } from 'connected-react-router';
import { goBack } from 'connected-react-router';
import { bindActionCreators } from 'redux';
import { vehicleDetails } from '../../modules/ticket';
import Button from '../button';
import LoginError from '../login/loginerror';
import { FIELD_EMPTY, ENTER_ALL_FIELDS } from '../../constants/general';

function VehicleDetails(props) {
  let ticketDetails = props.ticket.ticketDetails;
  const [manufacturer, setManufacturer] = useState(
    ticketDetails.vehicleManufacturer
  );
  const [type, setType] = useState(ticketDetails.vehicleType);
  const [color, setColor] = useState(ticketDetails.vehicleColor);
  const [validationError, seValidationError] = useState(null);
  let buttonStyle = validationError ? btnStyle : activeButtonStyle;
  const handleVManufChange = e => {
    setManufacturer(e.target.value);
    seValidationError(false);
  };
  const handleVTypeChnage = e => {
    setType(e.target.value);
    seValidationError(false);
  };
  const handleVColorChnage = e => {
    setColor(e.target.value);
    seValidationError(false);
  };
  const handleSettingsButton = () => {
    props.goToSettingsPage();
  };
  const handleNextButton = () => {
    if (!manufacturer || !manufacturer || !color) {
      seValidationError(FIELD_EMPTY);
    } else {
      props.vehicleDetails(manufacturer, type, color);
      props.goToViolationImagePage();
    }
  };
  return (
    <div className={divStyle}>
      <AppHeader
        title="Create Ticket"
        settingsIcon
        backIcon
        handleSettingsButton={handleSettingsButton}
        handleBackButton={props.prevPage}
      />
      <div>
        <div className={headerStyle}>
          <div className={progressBarStyle}></div>{' '}
        </div>
        {validationError ? (
          <LoginError
            content={validationError === FIELD_EMPTY ? ENTER_ALL_FIELDS : ''}
          />
        ) : null}
        <div className={container}>
          <div className={subContainer}>
            <div className={heading}> Vehicle Details </div>
            <div className={subHeading}> Enter the details below</div>
            <div className={listStyle}> Vehicle Manufacturer </div>
            <div className={textField}>
              <TextField
                type="text"
                value={manufacturer}
                placeholder="Enter vehicle manufacturer eg. Honda"
                inputClass={inputFieldStyle}
                onChange={e => handleVManufChange(e)}
              />
            </div>
            <div className={listStyle}>Vehicle Type</div>
            <div className={textField}>
              <TextField
                type="text"
                value={type}
                placeholder="Enter vehicle type eg. Civic"
                inputClass={inputFieldStyle}
                onChange={e => handleVTypeChnage(e)}
              />
            </div>
            <div className={listStyle}>Vehicle Color</div>
            <div className={textField}>
              <TextField
                type="text"
                value={color}
                placeholder="Enter vehicle color eg. Black"
                inputClass={inputFieldStyle}
                onChange={e => handleVColorChnage(e)}
              />
            </div>
          </div>
          <Button
            btnClassName={buttonStyle}
            text="NEXT"
            buttonClickCallback={handleNextButton}
            disabled={validationError}
          />
        </div>
      </div>
    </div>
  );
}
const divStyle = css({
  height: '100vh',
  backgroundColor: '#fafbfc'
});
const headerStyle = css({
  height: '8px',
  backgroundColor: '#ffffff'
});
const progressBarStyle = css({
  backgroundColor: '#34b37e',
  width: '57%',
  height: '8px',
  borderRadius: '0px 5px 5px 0px'
});
const container = css({
  margin: '16px 8px 0 8px'
});
const subContainer = css({
  backgroundColor: '#ffffff',
  fontFamily: 'sans-serif',
  marginBottom: '86px',
  fontStyle: 'normal',
  border: '1px solid #ebecf0',
  borderRadius: '1px',
  boxShadow: '2px 2px 2px 2px #23000000'
});
const heading = css({
  display: 'flex',
  alignItems: 'center',
  marginLeft: '16px',
  fontSize: '18px',
  color: '#212121',
  height: '50px'
});
const subHeading = css({
  margin: '0 0 24px 16px',
  fontSize: '14px',
  color: '#757575',
  height: '21px'
});
const listStyle = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: '0px 0 8px 16px',
  height: '24px'
});

const textField = css({
  height: '56px',
  margin: '0 16px 24px 16px',
  '::-webkit-input-placeholder': {
    color: '#bdbdbd'
  }
});
const inputFieldStyle = css({
  color: '#000000',
  fontSize: '14px',
  fontFamily: 'sans-serif',
  fontStyle: 'normal'
});
const activeButtonStyle = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'fixed',
  bottom: '0px',
  left: '0px',
  margin: '16px',
  height: '56px',
  width: 'calc(100% - 32px)',
  borderRadius: '2px',
  boxShadow: '0px 1px 3px #dbdbdb'
});
const btnStyle = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'fixed',
  bottom: '0px',
  left: '0px',
  margin: '16px',
  height: '56px',
  width: 'calc(100% - 32px)',
  borderRadius: '2px',
  boxShadow: '0px 1px 3px #dbdbdb',
  backgroundColor: '#dbdbdb'
});
const mapStateToProps = state => ({
  ticket: state.ticket
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      prevPage: () => goBack(),
      goToViolationImagePage: () => push('/violationImage'),
      goToSettingsPage: () => push('/settings'),
      vehicleDetails
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VehicleDetails);
